// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../commonapis/gen/buhta_common_v1_org_type.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_contractor from "./buhta_document_v1alpha1_contractor.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account from "./buhta_document_v1alpha1_contractor_bank_account.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetContractorRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2152,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetContractorResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2215,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListContractorsRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2275,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListContractorsResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2335,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateContractorRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2443,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ContractorData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateContractorResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2635,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateContractorRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2741,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ContractorData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateContractorResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2924,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteContractorRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2984,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteContractorResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3042,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateContractorBankAccountRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3099,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateContractorBankAccountResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3162,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateContractorBankAccountRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3224,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateContractorBankAccountResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3290,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteContractorBankAccountRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3351,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteContractorBankAccountResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3412,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ContractorBankAccountData = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      3471,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.document.v1alpha1.GetContractorRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.GetContractorRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.GetContractorRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetContractorRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.document.v1alpha1.GetContractorResponse";
}

function make$1(contractor, param) {
  return {
          contractor: contractor
        };
}

const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;

const merge_contractor = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "contractor",
            "contractor"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          contractor: Curry._2(merge_contractor, t1.contractor, t2.contractor)
        };
}

function spec$1(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "contractor",
                    "contractor"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.contractor);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(contractor) {
  return {
          contractor: contractor
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.GetContractorResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.contractor);
  };
}

function constructor$3(contractor) {
  return {
          contractor: contractor
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.GetContractorResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetContractorResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.document.v1alpha1.ListContractorsRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.ListContractorsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.ListContractorsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListContractorsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.document.v1alpha1.ListContractorsResponse";
}

function make$3(contractorsOpt, param) {
  const contractors = contractorsOpt !== undefined ? contractorsOpt : /* [] */0;
  return {
          contractors: contractors
        };
}

const $$let$2 = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;

const merge_contractors = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "contractors",
            "contractors"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          contractors: Curry._2(merge_contractors, t1.contractors, t2.contractors)
        };
}

function spec$3(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "contractors",
                    "contractors"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.contractors);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(contractors) {
  return {
          contractors: contractors
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.ListContractorsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.contractors);
  };
}

function constructor$7(contractors) {
  return {
          contractors: contractors
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.ListContractorsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListContractorsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const ContractorData = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2492,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$4(param) {
  return ".buhta.document.v1alpha1.CreateContractorRequest.ContractorData";
}

function make$4(tinOpt, type$pOpt, country_codeOpt, residentOpt, nameOpt, refnumOpt, emailOpt, phoneOpt, contactOpt, legal_addressOpt, real_addressOpt, chief_tinOpt, chief_positionOpt, chief_family_nameOpt, chief_given_nameOpt, chief_patronymic_nameOpt, chief_acting_onOpt, kbeOpt, bank_accountsOpt, param) {
  const tin = tinOpt !== undefined ? tinOpt : "";
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0);
  const country_code = country_codeOpt !== undefined ? country_codeOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const name = nameOpt !== undefined ? nameOpt : "";
  const refnum = refnumOpt !== undefined ? refnumOpt : "";
  const email = emailOpt !== undefined ? emailOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  const contact = contactOpt !== undefined ? contactOpt : "";
  const legal_address = legal_addressOpt !== undefined ? legal_addressOpt : "";
  const real_address = real_addressOpt !== undefined ? real_addressOpt : "";
  const chief_tin = chief_tinOpt !== undefined ? chief_tinOpt : "";
  const chief_position = chief_positionOpt !== undefined ? chief_positionOpt : "";
  const chief_family_name = chief_family_nameOpt !== undefined ? chief_family_nameOpt : "";
  const chief_given_name = chief_given_nameOpt !== undefined ? chief_given_nameOpt : "";
  const chief_patronymic_name = chief_patronymic_nameOpt !== undefined ? chief_patronymic_nameOpt : "";
  const chief_acting_on = chief_acting_onOpt !== undefined ? chief_acting_onOpt : "";
  const kbe = kbeOpt !== undefined ? kbeOpt : "";
  const bank_accounts = bank_accountsOpt !== undefined ? bank_accountsOpt : /* [] */0;
  return {
          tin: tin,
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          refnum: refnum,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe,
          bank_accounts: bank_accounts
        };
}

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
          Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
        ]));

const merge_country_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "country_code",
            "countryCode"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_refnum = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "refnum",
            "refnum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_contact = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "contact",
            "contact"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_legal_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "legal_address",
            "legalAddress"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_real_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "real_address",
            "realAddress"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "chief_tin",
            "chiefTin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            17,
            "chief_position",
            "chiefPosition"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            18,
            "chief_family_name",
            "chiefFamilyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            19,
            "chief_given_name",
            "chiefGivenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            20,
            "chief_patronymic_name",
            "chiefPatronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief_acting_on = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            21,
            "chief_acting_on",
            "chiefActingOn"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_kbe = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            31,
            "kbe",
            "kbe"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bank_accounts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            32,
            "bank_accounts",
            "bankAccounts"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ContractorBankAccountData.name,
                make: ContractorBankAccountData.make,
                from_proto: ContractorBankAccountData.from_proto,
                from_proto_exn: ContractorBankAccountData.from_proto_exn,
                to_proto: ContractorBankAccountData.to_proto,
                to_proto$p: ContractorBankAccountData.to_proto$p,
                merge: ContractorBankAccountData.merge,
                to_json: ContractorBankAccountData.to_json,
                from_json_exn: ContractorBankAccountData.from_json_exn,
                from_json: ContractorBankAccountData.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$4(t1, t2) {
  return {
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
          country_code: Curry._2(merge_country_code, t1.country_code, t2.country_code),
          resident: Curry._2(merge_resident, t1.resident, t2.resident),
          name: Curry._2(merge_name, t1.name, t2.name),
          refnum: Curry._2(merge_refnum, t1.refnum, t2.refnum),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone),
          contact: Curry._2(merge_contact, t1.contact, t2.contact),
          legal_address: Curry._2(merge_legal_address, t1.legal_address, t2.legal_address),
          real_address: Curry._2(merge_real_address, t1.real_address, t2.real_address),
          chief_tin: Curry._2(merge_chief_tin, t1.chief_tin, t2.chief_tin),
          chief_position: Curry._2(merge_chief_position, t1.chief_position, t2.chief_position),
          chief_family_name: Curry._2(merge_chief_family_name, t1.chief_family_name, t2.chief_family_name),
          chief_given_name: Curry._2(merge_chief_given_name, t1.chief_given_name, t2.chief_given_name),
          chief_patronymic_name: Curry._2(merge_chief_patronymic_name, t1.chief_patronymic_name, t2.chief_patronymic_name),
          chief_acting_on: Curry._2(merge_chief_acting_on, t1.chief_acting_on, t2.chief_acting_on),
          kbe: Curry._2(merge_kbe, t1.kbe, t2.kbe),
          bank_accounts: Curry._2(merge_bank_accounts, t1.bank_accounts, t2.bank_accounts)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "tin",
                    "tin"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "type",
                        "type"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
                      Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "country_code",
                            "countryCode"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "resident",
                                "resident"
                              ],
                              Ocaml_protoc_plugin__Spec.bool,
                              false
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "name",
                                    "name"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "refnum",
                                        "refnum"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "email",
                                            "email"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                8,
                                                "phone",
                                                "phone"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string,
                                              ""
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    9,
                                                    "contact",
                                                    "contact"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                      [
                                                        10,
                                                        "legal_address",
                                                        "legalAddress"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string,
                                                      ""
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                          [
                                                            11,
                                                            "real_address",
                                                            "realAddress"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.string,
                                                          ""
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                16,
                                                                "chief_tin",
                                                                "chiefTin"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    17,
                                                                    "chief_position",
                                                                    "chiefPosition"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                  ""
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                      [
                                                                        18,
                                                                        "chief_family_name",
                                                                        "chiefFamilyName"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                      ""
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                          [
                                                                            19,
                                                                            "chief_given_name",
                                                                            "chiefGivenName"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                          ""
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                              [
                                                                                20,
                                                                                "chief_patronymic_name",
                                                                                "chiefPatronymicName"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.string,
                                                                              ""
                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                  [
                                                                                    21,
                                                                                    "chief_acting_on",
                                                                                    "chiefActingOn"
                                                                                  ],
                                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                                  ""
                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                      [
                                                                                        31,
                                                                                        "kbe",
                                                                                        "kbe"
                                                                                      ],
                                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                                      ""
                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                                          [
                                                                                            32,
                                                                                            "bank_accounts",
                                                                                            "bankAccounts"
                                                                                          ],
                                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                                name: ContractorBankAccountData.name,
                                                                                                make: ContractorBankAccountData.make,
                                                                                                from_proto: ContractorBankAccountData.from_proto,
                                                                                                from_proto_exn: ContractorBankAccountData.from_proto_exn,
                                                                                                to_proto: ContractorBankAccountData.to_proto,
                                                                                                to_proto$p: ContractorBankAccountData.to_proto$p,
                                                                                                merge: ContractorBankAccountData.merge,
                                                                                                to_json: ContractorBankAccountData.to_json,
                                                                                                from_json_exn: ContractorBankAccountData.from_json_exn,
                                                                                                from_json: ContractorBankAccountData.from_json
                                                                                              }),
                                                                                          Ocaml_protoc_plugin__Spec.not_packed
                                                                                        ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))))))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry.app(serialize$4, [
        writer,
        param.tin,
        param["type'"],
        param.country_code,
        param.resident,
        param.name,
        param.refnum,
        param.email,
        param.phone,
        param.contact,
        param.legal_address,
        param.real_address,
        param.chief_tin,
        param.chief_position,
        param.chief_family_name,
        param.chief_given_name,
        param.chief_patronymic_name,
        param.chief_acting_on,
        param.kbe,
        param.bank_accounts
      ]);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(tin, type$p, country_code, resident, name, refnum, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe, bank_accounts) {
  return {
          tin: tin,
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          refnum: refnum,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe,
          bank_accounts: bank_accounts
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.CreateContractorRequest.ContractorData", spec$4(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.tin,
                param["type'"],
                param.country_code,
                param.resident,
                param.name,
                param.refnum,
                param.email,
                param.phone,
                param.contact,
                param.legal_address,
                param.real_address,
                param.chief_tin,
                param.chief_position,
                param.chief_family_name,
                param.chief_given_name,
                param.chief_patronymic_name,
                param.chief_acting_on,
                param.kbe,
                param.bank_accounts
              ]);
  };
}

function constructor$9(tin, type$p, country_code, resident, name, refnum, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe, bank_accounts) {
  return {
          tin: tin,
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          refnum: refnum,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe,
          bank_accounts: bank_accounts
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.CreateContractorRequest.ContractorData", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ContractorData, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.document.v1alpha1.CreateContractorRequest";
}

function make$5(contractor, param) {
  return {
          contractor: contractor
        };
}

const merge_contractor$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "contractor",
            "contractor"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ContractorData.name,
                make: ContractorData.make,
                from_proto: ContractorData.from_proto,
                from_proto_exn: ContractorData.from_proto_exn,
                to_proto: ContractorData.to_proto,
                to_proto$p: ContractorData.to_proto$p,
                merge: ContractorData.merge,
                to_json: ContractorData.to_json,
                from_json_exn: ContractorData.from_json_exn,
                from_json: ContractorData.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          contractor: Curry._2(merge_contractor$1, t1.contractor, t2.contractor)
        };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "contractor",
                    "contractor"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: ContractorData.name,
                        make: ContractorData.make,
                        from_proto: ContractorData.from_proto,
                        from_proto_exn: ContractorData.from_proto_exn,
                        to_proto: ContractorData.to_proto,
                        to_proto$p: ContractorData.to_proto$p,
                        merge: ContractorData.merge,
                        to_json: ContractorData.to_json,
                        from_json_exn: ContractorData.from_json_exn,
                        from_json: ContractorData.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.contractor);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(contractor) {
  return {
          contractor: contractor
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.CreateContractorRequest", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.contractor);
  };
}

function constructor$11(contractor) {
  return {
          contractor: contractor
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.CreateContractorRequest", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ContractorData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateContractorRequest, {
      ContractorData: ContractorData,
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.document.v1alpha1.CreateContractorResponse";
}

function make$6(contractor, param) {
  return {
          contractor: contractor
        };
}

const $$let$3 = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;

const merge_contractor$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "contractor",
            "contractor"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          contractor: Curry._2(merge_contractor$2, t1.contractor, t2.contractor)
        };
}

function spec$6(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "contractor",
                    "contractor"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.contractor);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(contractor) {
  return {
          contractor: contractor
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.CreateContractorResponse", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.contractor);
  };
}

function constructor$13(contractor) {
  return {
          contractor: contractor
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.CreateContractorResponse", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateContractorResponse, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

const ContractorData$1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.ml",
      2787,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$7(param) {
  return ".buhta.document.v1alpha1.UpdateContractorRequest.ContractorData";
}

function make$7(type$p, country_code, resident, name, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe, param) {
  return {
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe
        };
}

const merge_type$p$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType)
        ]));

const merge_country_code$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "country_code",
            "countryCode"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_resident$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool
        ]));

const merge_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            4,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_email$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_phone$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_contact$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "contact",
            "contact"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_legal_address$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "legal_address",
            "legalAddress"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_real_address$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            9,
            "real_address",
            "realAddress"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_tin$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            16,
            "chief_tin",
            "chiefTin"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_position$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            17,
            "chief_position",
            "chiefPosition"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_family_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            18,
            "chief_family_name",
            "chiefFamilyName"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_given_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            19,
            "chief_given_name",
            "chiefGivenName"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_patronymic_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            20,
            "chief_patronymic_name",
            "chiefPatronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_chief_acting_on$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            21,
            "chief_acting_on",
            "chiefActingOn"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_kbe$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            31,
            "kbe",
            "kbe"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge$7(t1, t2) {
  return {
          "type'": Curry._2(merge_type$p$1, t1["type'"], t2["type'"]),
          country_code: Curry._2(merge_country_code$1, t1.country_code, t2.country_code),
          resident: Curry._2(merge_resident$1, t1.resident, t2.resident),
          name: Curry._2(merge_name$1, t1.name, t2.name),
          email: Curry._2(merge_email$1, t1.email, t2.email),
          phone: Curry._2(merge_phone$1, t1.phone, t2.phone),
          contact: Curry._2(merge_contact$1, t1.contact, t2.contact),
          legal_address: Curry._2(merge_legal_address$1, t1.legal_address, t2.legal_address),
          real_address: Curry._2(merge_real_address$1, t1.real_address, t2.real_address),
          chief_tin: Curry._2(merge_chief_tin$1, t1.chief_tin, t2.chief_tin),
          chief_position: Curry._2(merge_chief_position$1, t1.chief_position, t2.chief_position),
          chief_family_name: Curry._2(merge_chief_family_name$1, t1.chief_family_name, t2.chief_family_name),
          chief_given_name: Curry._2(merge_chief_given_name$1, t1.chief_given_name, t2.chief_given_name),
          chief_patronymic_name: Curry._2(merge_chief_patronymic_name$1, t1.chief_patronymic_name, t2.chief_patronymic_name),
          chief_acting_on: Curry._2(merge_chief_acting_on$1, t1.chief_acting_on, t2.chief_acting_on),
          kbe: Curry._2(merge_kbe$1, t1.kbe, t2.kbe)
        };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "type",
                    "type"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "country_code",
                        "countryCode"
                      ],
                      Ocaml_protoc_plugin__Spec.string
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "resident",
                            "resident"
                          ],
                          Ocaml_protoc_plugin__Spec.bool
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                4,
                                "name",
                                "name"
                              ],
                              Ocaml_protoc_plugin__Spec.string
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "email",
                                    "email"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "phone",
                                        "phone"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "contact",
                                            "contact"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "legal_address",
                                                "legalAddress"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                  [
                                                    9,
                                                    "real_address",
                                                    "realAddress"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                      [
                                                        16,
                                                        "chief_tin",
                                                        "chiefTin"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                          [
                                                            17,
                                                            "chief_position",
                                                            "chiefPosition"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.string
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                              [
                                                                18,
                                                                "chief_family_name",
                                                                "chiefFamilyName"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                  [
                                                                    19,
                                                                    "chief_given_name",
                                                                    "chiefGivenName"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                      [
                                                                        20,
                                                                        "chief_patronymic_name",
                                                                        "chiefPatronymicName"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.string
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                          [
                                                                            21,
                                                                            "chief_acting_on",
                                                                            "chiefActingOn"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.string
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                              [
                                                                                31,
                                                                                "kbe",
                                                                                "kbe"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.string
                                                                            ]), Ocaml_protoc_plugin__Spec.nil))))))))))))))));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry.app(serialize$7, [
        writer,
        param["type'"],
        param.country_code,
        param.resident,
        param.name,
        param.email,
        param.phone,
        param.contact,
        param.legal_address,
        param.real_address,
        param.chief_tin,
        param.chief_position,
        param.chief_family_name,
        param.chief_given_name,
        param.chief_patronymic_name,
        param.chief_acting_on,
        param.kbe
      ]);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(type$p, country_code, resident, name, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe) {
  return {
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.UpdateContractorRequest.ContractorData", spec$7(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param["type'"],
                param.country_code,
                param.resident,
                param.name,
                param.email,
                param.phone,
                param.contact,
                param.legal_address,
                param.real_address,
                param.chief_tin,
                param.chief_position,
                param.chief_family_name,
                param.chief_given_name,
                param.chief_patronymic_name,
                param.chief_acting_on,
                param.kbe
              ]);
  };
}

function constructor$15(type$p, country_code, resident, name, email, phone, contact, legal_address, real_address, chief_tin, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, chief_acting_on, kbe) {
  return {
          "type'": type$p,
          country_code: country_code,
          resident: resident,
          name: name,
          email: email,
          phone: phone,
          contact: contact,
          legal_address: legal_address,
          real_address: real_address,
          chief_tin: chief_tin,
          chief_position: chief_position,
          chief_family_name: chief_family_name,
          chief_given_name: chief_given_name,
          chief_patronymic_name: chief_patronymic_name,
          chief_acting_on: chief_acting_on,
          kbe: kbe
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.UpdateContractorRequest.ContractorData", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ContractorData$1, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.document.v1alpha1.UpdateContractorRequest";
}

function make$8(idOpt, contractor, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id,
          contractor: contractor
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_contractor$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "contractor",
            "contractor"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ContractorData$1.name,
                make: ContractorData$1.make,
                from_proto: ContractorData$1.from_proto,
                from_proto_exn: ContractorData$1.from_proto_exn,
                to_proto: ContractorData$1.to_proto,
                to_proto$p: ContractorData$1.to_proto$p,
                merge: ContractorData$1.merge,
                to_json: ContractorData$1.to_json,
                from_json_exn: ContractorData$1.from_json_exn,
                from_json: ContractorData$1.from_json
              })
        ]));

function merge$8(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          contractor: Curry._2(merge_contractor$3, t1.contractor, t2.contractor)
        };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "contractor",
                        "contractor"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: ContractorData$1.name,
                            make: ContractorData$1.make,
                            from_proto: ContractorData$1.from_proto,
                            from_proto_exn: ContractorData$1.from_proto_exn,
                            to_proto: ContractorData$1.to_proto,
                            to_proto$p: ContractorData$1.to_proto$p,
                            merge: ContractorData$1.merge,
                            to_json: ContractorData$1.to_json,
                            from_json_exn: ContractorData$1.from_json_exn,
                            from_json: ContractorData$1.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._3(serialize$8, writer, param.id, param.contractor);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(id, contractor) {
  return {
          id: id,
          contractor: contractor
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.UpdateContractorRequest", spec$8(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.contractor);
  };
}

function constructor$17(id, contractor) {
  return {
          id: id,
          contractor: contractor
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.UpdateContractorRequest", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ContractorData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateContractorRequest, {
      ContractorData: ContractorData$1,
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

function name$9(param) {
  return ".buhta.document.v1alpha1.UpdateContractorResponse";
}

function make$9(contractor, param) {
  return {
          contractor: contractor
        };
}

const $$let$4 = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;

const merge_contractor$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "contractor",
            "contractor"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$9(t1, t2) {
  return {
          contractor: Curry._2(merge_contractor$4, t1.contractor, t2.contractor)
        };
}

function spec$9(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor.Buhta.$$Document.V1alpha1.Contractor;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "contractor",
                    "contractor"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
    });

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.contractor);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(contractor) {
  return {
          contractor: contractor
        };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
    });

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$9, writer);
            });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.UpdateContractorResponse", spec$9(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.contractor);
  };
}

function constructor$19(contractor) {
  return {
          contractor: contractor
        };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.UpdateContractorResponse", spec$9(undefined), constructor$19);
    });

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$9, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateContractorResponse, {
      make: make$9,
      to_proto: to_proto$9,
      from_proto: from_proto$9,
      to_json: to_json$9,
      from_json: from_json$9,
      name: name$9,
      merge: merge$9,
      to_proto$p: to_proto$p$9,
      from_proto_exn: from_proto_exn$9,
      from_json_exn: from_json_exn$9
    });

function name$10(param) {
  return ".buhta.document.v1alpha1.DeleteContractorRequest";
}

function make$10(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id
        };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$10(t1, t2) {
  return {
          id: Curry._2(merge_id$2, t1.id, t2.id)
        };
}

function spec$10(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$10(undefined));
    });

function to_proto$p$10(writer, param) {
  Curry._2(serialize$10, writer, param.id);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$10(writer, t);
  return writer;
}

function constructor$20(id) {
  return {
          id: id
        };
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$10(undefined), constructor$20);
    });

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$10, writer);
            });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DeleteContractorRequest", spec$10(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$21(id) {
  return {
          id: id
        };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DeleteContractorRequest", spec$10(undefined), constructor$21);
    });

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$10, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteContractorRequest, {
      make: make$10,
      to_proto: to_proto$10,
      from_proto: from_proto$10,
      to_json: to_json$10,
      from_json: from_json$10,
      name: name$10,
      merge: merge$10,
      to_proto$p: to_proto$p$10,
      from_proto_exn: from_proto_exn$10,
      from_json_exn: from_json_exn$10
    });

function name$11(param) {
  return ".buhta.document.v1alpha1.DeleteContractorResponse";
}

function make$11(param) {
  
}

function merge$11(param, param$1) {
  
}

const serialize$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p$11(writer, param) {
  Curry._1(serialize$11, writer);
}

function to_proto$11(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$11, writer);
  return writer;
}

const from_proto_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto$11(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn$11, writer);
            });
}

function to_json$11(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DeleteContractorResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DeleteContractorResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json$11(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn$11, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteContractorResponse, {
      make: make$11,
      to_proto: to_proto$11,
      from_proto: from_proto$11,
      to_json: to_json$11,
      from_json: from_json$11,
      name: name$11,
      merge: merge$11,
      to_proto$p: to_proto$p$11,
      from_proto_exn: from_proto_exn$11,
      from_json_exn: from_json_exn$11
    });

function name$12(param) {
  return ".buhta.document.v1alpha1.CreateContractorBankAccountRequest";
}

function make$12(contractor_idOpt, bank_account, param) {
  const contractor_id = contractor_idOpt !== undefined ? contractor_idOpt : "";
  return {
          contractor_id: contractor_id,
          bank_account: bank_account
        };
}

const merge_contractor_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "contractor_id",
            "contractorId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bank_account = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "bank_account",
            "bankAccount"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ContractorBankAccountData.name,
                make: ContractorBankAccountData.make,
                from_proto: ContractorBankAccountData.from_proto,
                from_proto_exn: ContractorBankAccountData.from_proto_exn,
                to_proto: ContractorBankAccountData.to_proto,
                to_proto$p: ContractorBankAccountData.to_proto$p,
                merge: ContractorBankAccountData.merge,
                to_json: ContractorBankAccountData.to_json,
                from_json_exn: ContractorBankAccountData.from_json_exn,
                from_json: ContractorBankAccountData.from_json
              })
        ]));

function merge$12(t1, t2) {
  return {
          contractor_id: Curry._2(merge_contractor_id, t1.contractor_id, t2.contractor_id),
          bank_account: Curry._2(merge_bank_account, t1.bank_account, t2.bank_account)
        };
}

function spec$11(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "contractor_id",
                    "contractorId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "bank_account",
                        "bankAccount"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: ContractorBankAccountData.name,
                            make: ContractorBankAccountData.make,
                            from_proto: ContractorBankAccountData.from_proto,
                            from_proto_exn: ContractorBankAccountData.from_proto_exn,
                            to_proto: ContractorBankAccountData.to_proto,
                            to_proto$p: ContractorBankAccountData.to_proto$p,
                            merge: ContractorBankAccountData.merge,
                            to_json: ContractorBankAccountData.to_json,
                            from_json_exn: ContractorBankAccountData.from_json_exn,
                            from_json: ContractorBankAccountData.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$11(undefined));
    });

function to_proto$p$12(writer, param) {
  Curry._3(serialize$12, writer, param.contractor_id, param.bank_account);
}

function to_proto$12(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$12(writer, t);
  return writer;
}

function constructor$22(contractor_id, bank_account) {
  return {
          contractor_id: contractor_id,
          bank_account: bank_account
        };
}

const from_proto_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$11(undefined), constructor$22);
    });

function from_proto$12(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$12, writer);
            });
}

function to_json$12(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.CreateContractorBankAccountRequest", spec$11(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.contractor_id, param.bank_account);
  };
}

function constructor$23(contractor_id, bank_account) {
  return {
          contractor_id: contractor_id,
          bank_account: bank_account
        };
}

const from_json_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.CreateContractorBankAccountRequest", spec$11(undefined), constructor$23);
    });

function from_json$12(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$12, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateContractorBankAccountRequest, {
      make: make$12,
      to_proto: to_proto$12,
      from_proto: from_proto$12,
      to_json: to_json$12,
      from_json: from_json$12,
      name: name$12,
      merge: merge$12,
      to_proto$p: to_proto$p$12,
      from_proto_exn: from_proto_exn$12,
      from_json_exn: from_json_exn$12
    });

function name$13(param) {
  return ".buhta.document.v1alpha1.CreateContractorBankAccountResponse";
}

function make$13(bank_account, param) {
  return {
          bank_account: bank_account
        };
}

const $$let$5 = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;

const merge_bank_account$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "bank_account",
            "bankAccount"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

function merge$13(t1, t2) {
  return {
          bank_account: Curry._2(merge_bank_account$1, t1.bank_account, t2.bank_account)
        };
}

function spec$12(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "bank_account",
                    "bankAccount"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$12(undefined));
    });

function to_proto$p$13(writer, param) {
  Curry._2(serialize$13, writer, param.bank_account);
}

function to_proto$13(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$13(writer, t);
  return writer;
}

function constructor$24(bank_account) {
  return {
          bank_account: bank_account
        };
}

const from_proto_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$12(undefined), constructor$24);
    });

function from_proto$13(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$13, writer);
            });
}

function to_json$13(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.CreateContractorBankAccountResponse", spec$12(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.bank_account);
  };
}

function constructor$25(bank_account) {
  return {
          bank_account: bank_account
        };
}

const from_json_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.CreateContractorBankAccountResponse", spec$12(undefined), constructor$25);
    });

function from_json$13(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$13, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateContractorBankAccountResponse, {
      make: make$13,
      to_proto: to_proto$13,
      from_proto: from_proto$13,
      to_json: to_json$13,
      from_json: from_json$13,
      name: name$13,
      merge: merge$13,
      to_proto$p: to_proto$p$13,
      from_proto_exn: from_proto_exn$13,
      from_json_exn: from_json_exn$13
    });

function name$14(param) {
  return ".buhta.document.v1alpha1.UpdateContractorBankAccountRequest";
}

function make$14(contractor_idOpt, idOpt, bank_account, param) {
  const contractor_id = contractor_idOpt !== undefined ? contractor_idOpt : "";
  const id = idOpt !== undefined ? idOpt : "";
  return {
          contractor_id: contractor_id,
          id: id,
          bank_account: bank_account
        };
}

const merge_contractor_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "contractor_id",
            "contractorId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_id$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bank_account$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "bank_account",
            "bankAccount"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ContractorBankAccountData.name,
                make: ContractorBankAccountData.make,
                from_proto: ContractorBankAccountData.from_proto,
                from_proto_exn: ContractorBankAccountData.from_proto_exn,
                to_proto: ContractorBankAccountData.to_proto,
                to_proto$p: ContractorBankAccountData.to_proto$p,
                merge: ContractorBankAccountData.merge,
                to_json: ContractorBankAccountData.to_json,
                from_json_exn: ContractorBankAccountData.from_json_exn,
                from_json: ContractorBankAccountData.from_json
              })
        ]));

function merge$14(t1, t2) {
  return {
          contractor_id: Curry._2(merge_contractor_id$1, t1.contractor_id, t2.contractor_id),
          id: Curry._2(merge_id$3, t1.id, t2.id),
          bank_account: Curry._2(merge_bank_account$2, t1.bank_account, t2.bank_account)
        };
}

function spec$13(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "contractor_id",
                    "contractorId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "bank_account",
                            "bankAccount"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: ContractorBankAccountData.name,
                                make: ContractorBankAccountData.make,
                                from_proto: ContractorBankAccountData.from_proto,
                                from_proto_exn: ContractorBankAccountData.from_proto_exn,
                                to_proto: ContractorBankAccountData.to_proto,
                                to_proto$p: ContractorBankAccountData.to_proto$p,
                                merge: ContractorBankAccountData.merge,
                                to_json: ContractorBankAccountData.to_json,
                                from_json_exn: ContractorBankAccountData.from_json_exn,
                                from_json: ContractorBankAccountData.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$13(undefined));
    });

function to_proto$p$14(writer, param) {
  Curry._4(serialize$14, writer, param.contractor_id, param.id, param.bank_account);
}

function to_proto$14(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$14(writer, t);
  return writer;
}

function constructor$26(contractor_id, id, bank_account) {
  return {
          contractor_id: contractor_id,
          id: id,
          bank_account: bank_account
        };
}

const from_proto_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$13(undefined), constructor$26);
    });

function from_proto$14(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$14, writer);
            });
}

function to_json$14(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.UpdateContractorBankAccountRequest", spec$13(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.contractor_id, param.id, param.bank_account);
  };
}

function constructor$27(contractor_id, id, bank_account) {
  return {
          contractor_id: contractor_id,
          id: id,
          bank_account: bank_account
        };
}

const from_json_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.UpdateContractorBankAccountRequest", spec$13(undefined), constructor$27);
    });

function from_json$14(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$14, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateContractorBankAccountRequest, {
      make: make$14,
      to_proto: to_proto$14,
      from_proto: from_proto$14,
      to_json: to_json$14,
      from_json: from_json$14,
      name: name$14,
      merge: merge$14,
      to_proto$p: to_proto$p$14,
      from_proto_exn: from_proto_exn$14,
      from_json_exn: from_json_exn$14
    });

function name$15(param) {
  return ".buhta.document.v1alpha1.UpdateContractorBankAccountResponse";
}

function make$15(bank_account, param) {
  return {
          bank_account: bank_account
        };
}

const $$let$6 = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;

const merge_bank_account$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "bank_account",
            "bankAccount"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$6.name,
                make: $$let$6.make,
                from_proto: $$let$6.from_proto,
                from_proto_exn: $$let$6.from_proto_exn,
                to_proto: $$let$6.to_proto,
                to_proto$p: $$let$6.to_proto$p,
                merge: $$let$6.merge,
                to_json: $$let$6.to_json,
                from_json_exn: $$let$6.from_json_exn,
                from_json: $$let$6.from_json
              })
        ]));

function merge$15(t1, t2) {
  return {
          bank_account: Curry._2(merge_bank_account$3, t1.bank_account, t2.bank_account)
        };
}

function spec$14(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_contractor_bank_account.Buhta.$$Document.V1alpha1.ContractorBankAccount;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "bank_account",
                    "bankAccount"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$14(undefined));
    });

function to_proto$p$15(writer, param) {
  Curry._2(serialize$15, writer, param.bank_account);
}

function to_proto$15(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$15(writer, t);
  return writer;
}

function constructor$28(bank_account) {
  return {
          bank_account: bank_account
        };
}

const from_proto_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$14(undefined), constructor$28);
    });

function from_proto$15(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$15, writer);
            });
}

function to_json$15(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.UpdateContractorBankAccountResponse", spec$14(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.bank_account);
  };
}

function constructor$29(bank_account) {
  return {
          bank_account: bank_account
        };
}

const from_json_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.UpdateContractorBankAccountResponse", spec$14(undefined), constructor$29);
    });

function from_json$15(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$15, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateContractorBankAccountResponse, {
      make: make$15,
      to_proto: to_proto$15,
      from_proto: from_proto$15,
      to_json: to_json$15,
      from_json: from_json$15,
      name: name$15,
      merge: merge$15,
      to_proto$p: to_proto$p$15,
      from_proto_exn: from_proto_exn$15,
      from_json_exn: from_json_exn$15
    });

function name$16(param) {
  return ".buhta.document.v1alpha1.DeleteContractorBankAccountRequest";
}

function make$16(contractor_idOpt, idOpt, param) {
  const contractor_id = contractor_idOpt !== undefined ? contractor_idOpt : "";
  const id = idOpt !== undefined ? idOpt : "";
  return {
          contractor_id: contractor_id,
          id: id
        };
}

const merge_contractor_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "contractor_id",
            "contractorId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_id$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$16(t1, t2) {
  return {
          contractor_id: Curry._2(merge_contractor_id$2, t1.contractor_id, t2.contractor_id),
          id: Curry._2(merge_id$4, t1.id, t2.id)
        };
}

function spec$15(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "contractor_id",
                    "contractorId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$15(undefined));
    });

function to_proto$p$16(writer, param) {
  Curry._3(serialize$16, writer, param.contractor_id, param.id);
}

function to_proto$16(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$16(writer, t);
  return writer;
}

function constructor$30(contractor_id, id) {
  return {
          contractor_id: contractor_id,
          id: id
        };
}

const from_proto_exn$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$15(undefined), constructor$30);
    });

function from_proto$16(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$16, writer);
            });
}

function to_json$16(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DeleteContractorBankAccountRequest", spec$15(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.contractor_id, param.id);
  };
}

function constructor$31(contractor_id, id) {
  return {
          contractor_id: contractor_id,
          id: id
        };
}

const from_json_exn$16 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DeleteContractorBankAccountRequest", spec$15(undefined), constructor$31);
    });

function from_json$16(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$16, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteContractorBankAccountRequest, {
      make: make$16,
      to_proto: to_proto$16,
      from_proto: from_proto$16,
      to_json: to_json$16,
      from_json: from_json$16,
      name: name$16,
      merge: merge$16,
      to_proto$p: to_proto$p$16,
      from_proto_exn: from_proto_exn$16,
      from_json_exn: from_json_exn$16
    });

function name$17(param) {
  return ".buhta.document.v1alpha1.DeleteContractorBankAccountResponse";
}

function make$17(param) {
  
}

function merge$17(param, param$1) {
  
}

const serialize$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p$17(writer, param) {
  Curry._1(serialize$17, writer);
}

function to_proto$17(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$17, writer);
  return writer;
}

const from_proto_exn$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto$17(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn$17, writer);
            });
}

function to_json$17(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.DeleteContractorBankAccountResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$17 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.DeleteContractorBankAccountResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json$17(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn$17, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteContractorBankAccountResponse, {
      make: make$17,
      to_proto: to_proto$17,
      from_proto: from_proto$17,
      to_json: to_json$17,
      from_json: from_json$17,
      name: name$17,
      merge: merge$17,
      to_proto$p: to_proto$p$17,
      from_proto_exn: from_proto_exn$17,
      from_json_exn: from_json_exn$17
    });

function name$18(param) {
  return ".buhta.document.v1alpha1.ContractorBankAccountData";
}

function make$18(ibanOpt, bank_nameOpt, bicOpt, defaultOpt, param) {
  const iban = ibanOpt !== undefined ? ibanOpt : "";
  const bank_name = bank_nameOpt !== undefined ? bank_nameOpt : "";
  const bic = bicOpt !== undefined ? bicOpt : "";
  const $$default = defaultOpt !== undefined ? defaultOpt : false;
  return {
          iban: iban,
          bank_name: bank_name,
          bic: bic,
          default: $$default
        };
}

const merge_iban = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "iban",
            "iban"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bank_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "bank_name",
            "bankName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bic = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "bic",
            "bic"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_default = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "default",
            "default"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$18(t1, t2) {
  return {
          iban: Curry._2(merge_iban, t1.iban, t2.iban),
          bank_name: Curry._2(merge_bank_name, t1.bank_name, t2.bank_name),
          bic: Curry._2(merge_bic, t1.bic, t2.bic),
          default: Curry._2(merge_default, t1.default, t2.default)
        };
}

function spec$16(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "iban",
                    "iban"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "bank_name",
                        "bankName"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "bic",
                            "bic"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "default",
                                "default"
                              ],
                              Ocaml_protoc_plugin__Spec.bool,
                              false
                            ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$16(undefined));
    });

function to_proto$p$18(writer, param) {
  Curry._5(serialize$18, writer, param.iban, param.bank_name, param.bic, param.default);
}

function to_proto$18(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$18(writer, t);
  return writer;
}

function constructor$32(iban, bank_name, bic, $$default) {
  return {
          iban: iban,
          bank_name: bank_name,
          bic: bic,
          default: $$default
        };
}

const from_proto_exn$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$16(undefined), constructor$32);
    });

function from_proto$18(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$18, writer);
            });
}

function to_json$18(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.document.v1alpha1.ContractorBankAccountData", spec$16(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.iban, param.bank_name, param.bic, param.default);
  };
}

function constructor$33(iban, bank_name, bic, $$default) {
  return {
          iban: iban,
          bank_name: bank_name,
          bic: bic,
          default: $$default
        };
}

const from_json_exn$18 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.document.v1alpha1.ContractorBankAccountData", spec$16(undefined), constructor$33);
    });

function from_json$18(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$18, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ContractorBankAccountData, {
      make: make$18,
      to_proto: to_proto$18,
      from_proto: from_proto$18,
      to_json: to_json$18,
      from_json: from_json$18,
      name: name$18,
      merge: merge$18,
      to_proto$p: to_proto$p$18,
      from_proto_exn: from_proto_exn$18,
      from_json_exn: from_json_exn$18
    });

const getContractor_0 = {
  name: GetContractorRequest.name,
  make: GetContractorRequest.make,
  from_proto: GetContractorRequest.from_proto,
  from_proto_exn: GetContractorRequest.from_proto_exn,
  to_proto: GetContractorRequest.to_proto,
  to_proto$p: GetContractorRequest.to_proto$p,
  merge: GetContractorRequest.merge,
  to_json: GetContractorRequest.to_json,
  from_json_exn: GetContractorRequest.from_json_exn,
  from_json: GetContractorRequest.from_json
};

const getContractor_1 = {
  name: GetContractorResponse.name,
  make: GetContractorResponse.make,
  from_proto: GetContractorResponse.from_proto,
  from_proto_exn: GetContractorResponse.from_proto_exn,
  to_proto: GetContractorResponse.to_proto,
  to_proto$p: GetContractorResponse.to_proto$p,
  merge: GetContractorResponse.merge,
  to_json: GetContractorResponse.to_json,
  from_json_exn: GetContractorResponse.from_json_exn,
  from_json: GetContractorResponse.from_json
};

const getContractor = [
  getContractor_0,
  getContractor_1
];

const listContractors_0 = {
  name: ListContractorsRequest.name,
  make: ListContractorsRequest.make,
  from_proto: ListContractorsRequest.from_proto,
  from_proto_exn: ListContractorsRequest.from_proto_exn,
  to_proto: ListContractorsRequest.to_proto,
  to_proto$p: ListContractorsRequest.to_proto$p,
  merge: ListContractorsRequest.merge,
  to_json: ListContractorsRequest.to_json,
  from_json_exn: ListContractorsRequest.from_json_exn,
  from_json: ListContractorsRequest.from_json
};

const listContractors_1 = {
  name: ListContractorsResponse.name,
  make: ListContractorsResponse.make,
  from_proto: ListContractorsResponse.from_proto,
  from_proto_exn: ListContractorsResponse.from_proto_exn,
  to_proto: ListContractorsResponse.to_proto,
  to_proto$p: ListContractorsResponse.to_proto$p,
  merge: ListContractorsResponse.merge,
  to_json: ListContractorsResponse.to_json,
  from_json_exn: ListContractorsResponse.from_json_exn,
  from_json: ListContractorsResponse.from_json
};

const listContractors = [
  listContractors_0,
  listContractors_1
];

const createContractor_0 = {
  name: CreateContractorRequest.name,
  make: CreateContractorRequest.make,
  from_proto: CreateContractorRequest.from_proto,
  from_proto_exn: CreateContractorRequest.from_proto_exn,
  to_proto: CreateContractorRequest.to_proto,
  to_proto$p: CreateContractorRequest.to_proto$p,
  merge: CreateContractorRequest.merge,
  to_json: CreateContractorRequest.to_json,
  from_json_exn: CreateContractorRequest.from_json_exn,
  from_json: CreateContractorRequest.from_json
};

const createContractor_1 = {
  name: CreateContractorResponse.name,
  make: CreateContractorResponse.make,
  from_proto: CreateContractorResponse.from_proto,
  from_proto_exn: CreateContractorResponse.from_proto_exn,
  to_proto: CreateContractorResponse.to_proto,
  to_proto$p: CreateContractorResponse.to_proto$p,
  merge: CreateContractorResponse.merge,
  to_json: CreateContractorResponse.to_json,
  from_json_exn: CreateContractorResponse.from_json_exn,
  from_json: CreateContractorResponse.from_json
};

const createContractor = [
  createContractor_0,
  createContractor_1
];

const updateContractor_0 = {
  name: UpdateContractorRequest.name,
  make: UpdateContractorRequest.make,
  from_proto: UpdateContractorRequest.from_proto,
  from_proto_exn: UpdateContractorRequest.from_proto_exn,
  to_proto: UpdateContractorRequest.to_proto,
  to_proto$p: UpdateContractorRequest.to_proto$p,
  merge: UpdateContractorRequest.merge,
  to_json: UpdateContractorRequest.to_json,
  from_json_exn: UpdateContractorRequest.from_json_exn,
  from_json: UpdateContractorRequest.from_json
};

const updateContractor_1 = {
  name: UpdateContractorResponse.name,
  make: UpdateContractorResponse.make,
  from_proto: UpdateContractorResponse.from_proto,
  from_proto_exn: UpdateContractorResponse.from_proto_exn,
  to_proto: UpdateContractorResponse.to_proto,
  to_proto$p: UpdateContractorResponse.to_proto$p,
  merge: UpdateContractorResponse.merge,
  to_json: UpdateContractorResponse.to_json,
  from_json_exn: UpdateContractorResponse.from_json_exn,
  from_json: UpdateContractorResponse.from_json
};

const updateContractor = [
  updateContractor_0,
  updateContractor_1
];

const deleteContractor_0 = {
  name: DeleteContractorRequest.name,
  make: DeleteContractorRequest.make,
  from_proto: DeleteContractorRequest.from_proto,
  from_proto_exn: DeleteContractorRequest.from_proto_exn,
  to_proto: DeleteContractorRequest.to_proto,
  to_proto$p: DeleteContractorRequest.to_proto$p,
  merge: DeleteContractorRequest.merge,
  to_json: DeleteContractorRequest.to_json,
  from_json_exn: DeleteContractorRequest.from_json_exn,
  from_json: DeleteContractorRequest.from_json
};

const deleteContractor_1 = {
  name: DeleteContractorResponse.name,
  make: DeleteContractorResponse.make,
  from_proto: DeleteContractorResponse.from_proto,
  from_proto_exn: DeleteContractorResponse.from_proto_exn,
  to_proto: DeleteContractorResponse.to_proto,
  to_proto$p: DeleteContractorResponse.to_proto$p,
  merge: DeleteContractorResponse.merge,
  to_json: DeleteContractorResponse.to_json,
  from_json_exn: DeleteContractorResponse.from_json_exn,
  from_json: DeleteContractorResponse.from_json
};

const deleteContractor = [
  deleteContractor_0,
  deleteContractor_1
];

const createContractorBankAccount_0 = {
  name: CreateContractorBankAccountRequest.name,
  make: CreateContractorBankAccountRequest.make,
  from_proto: CreateContractorBankAccountRequest.from_proto,
  from_proto_exn: CreateContractorBankAccountRequest.from_proto_exn,
  to_proto: CreateContractorBankAccountRequest.to_proto,
  to_proto$p: CreateContractorBankAccountRequest.to_proto$p,
  merge: CreateContractorBankAccountRequest.merge,
  to_json: CreateContractorBankAccountRequest.to_json,
  from_json_exn: CreateContractorBankAccountRequest.from_json_exn,
  from_json: CreateContractorBankAccountRequest.from_json
};

const createContractorBankAccount_1 = {
  name: CreateContractorBankAccountResponse.name,
  make: CreateContractorBankAccountResponse.make,
  from_proto: CreateContractorBankAccountResponse.from_proto,
  from_proto_exn: CreateContractorBankAccountResponse.from_proto_exn,
  to_proto: CreateContractorBankAccountResponse.to_proto,
  to_proto$p: CreateContractorBankAccountResponse.to_proto$p,
  merge: CreateContractorBankAccountResponse.merge,
  to_json: CreateContractorBankAccountResponse.to_json,
  from_json_exn: CreateContractorBankAccountResponse.from_json_exn,
  from_json: CreateContractorBankAccountResponse.from_json
};

const createContractorBankAccount = [
  createContractorBankAccount_0,
  createContractorBankAccount_1
];

const updateContractorBankAccount_0 = {
  name: UpdateContractorBankAccountRequest.name,
  make: UpdateContractorBankAccountRequest.make,
  from_proto: UpdateContractorBankAccountRequest.from_proto,
  from_proto_exn: UpdateContractorBankAccountRequest.from_proto_exn,
  to_proto: UpdateContractorBankAccountRequest.to_proto,
  to_proto$p: UpdateContractorBankAccountRequest.to_proto$p,
  merge: UpdateContractorBankAccountRequest.merge,
  to_json: UpdateContractorBankAccountRequest.to_json,
  from_json_exn: UpdateContractorBankAccountRequest.from_json_exn,
  from_json: UpdateContractorBankAccountRequest.from_json
};

const updateContractorBankAccount_1 = {
  name: UpdateContractorBankAccountResponse.name,
  make: UpdateContractorBankAccountResponse.make,
  from_proto: UpdateContractorBankAccountResponse.from_proto,
  from_proto_exn: UpdateContractorBankAccountResponse.from_proto_exn,
  to_proto: UpdateContractorBankAccountResponse.to_proto,
  to_proto$p: UpdateContractorBankAccountResponse.to_proto$p,
  merge: UpdateContractorBankAccountResponse.merge,
  to_json: UpdateContractorBankAccountResponse.to_json,
  from_json_exn: UpdateContractorBankAccountResponse.from_json_exn,
  from_json: UpdateContractorBankAccountResponse.from_json
};

const updateContractorBankAccount = [
  updateContractorBankAccount_0,
  updateContractorBankAccount_1
];

const deleteContractorBankAccount_0 = {
  name: DeleteContractorBankAccountRequest.name,
  make: DeleteContractorBankAccountRequest.make,
  from_proto: DeleteContractorBankAccountRequest.from_proto,
  from_proto_exn: DeleteContractorBankAccountRequest.from_proto_exn,
  to_proto: DeleteContractorBankAccountRequest.to_proto,
  to_proto$p: DeleteContractorBankAccountRequest.to_proto$p,
  merge: DeleteContractorBankAccountRequest.merge,
  to_json: DeleteContractorBankAccountRequest.to_json,
  from_json_exn: DeleteContractorBankAccountRequest.from_json_exn,
  from_json: DeleteContractorBankAccountRequest.from_json
};

const deleteContractorBankAccount_1 = {
  name: DeleteContractorBankAccountResponse.name,
  make: DeleteContractorBankAccountResponse.make,
  from_proto: DeleteContractorBankAccountResponse.from_proto,
  from_proto_exn: DeleteContractorBankAccountResponse.from_proto_exn,
  to_proto: DeleteContractorBankAccountResponse.to_proto,
  to_proto$p: DeleteContractorBankAccountResponse.to_proto$p,
  merge: DeleteContractorBankAccountResponse.merge,
  to_json: DeleteContractorBankAccountResponse.to_json,
  from_json_exn: DeleteContractorBankAccountResponse.from_json_exn,
  from_json: DeleteContractorBankAccountResponse.from_json
};

const deleteContractorBankAccount = [
  deleteContractorBankAccount_0,
  deleteContractorBankAccount_1
];

const V1alpha1_ContractorService = {
  GetContractor: {
    name: "/buhta.document.v1alpha1.ContractorService/GetContractor",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "GetContractor",
    $$Request: {
      name: GetContractorRequest.name,
      make: GetContractorRequest.make,
      from_proto: GetContractorRequest.from_proto,
      from_proto_exn: GetContractorRequest.from_proto_exn,
      to_proto: GetContractorRequest.to_proto,
      to_proto$p: GetContractorRequest.to_proto$p,
      merge: GetContractorRequest.merge,
      to_json: GetContractorRequest.to_json,
      from_json_exn: GetContractorRequest.from_json_exn,
      from_json: GetContractorRequest.from_json
    },
    $$Response: {
      name: GetContractorResponse.name,
      make: GetContractorResponse.make,
      from_proto: GetContractorResponse.from_proto,
      from_proto_exn: GetContractorResponse.from_proto_exn,
      to_proto: GetContractorResponse.to_proto,
      to_proto$p: GetContractorResponse.to_proto$p,
      merge: GetContractorResponse.merge,
      to_json: GetContractorResponse.to_json,
      from_json_exn: GetContractorResponse.from_json_exn,
      from_json: GetContractorResponse.from_json
    }
  },
  getContractor: getContractor,
  ListContractors: {
    name: "/buhta.document.v1alpha1.ContractorService/ListContractors",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "ListContractors",
    $$Request: {
      name: ListContractorsRequest.name,
      make: ListContractorsRequest.make,
      from_proto: ListContractorsRequest.from_proto,
      from_proto_exn: ListContractorsRequest.from_proto_exn,
      to_proto: ListContractorsRequest.to_proto,
      to_proto$p: ListContractorsRequest.to_proto$p,
      merge: ListContractorsRequest.merge,
      to_json: ListContractorsRequest.to_json,
      from_json_exn: ListContractorsRequest.from_json_exn,
      from_json: ListContractorsRequest.from_json
    },
    $$Response: {
      name: ListContractorsResponse.name,
      make: ListContractorsResponse.make,
      from_proto: ListContractorsResponse.from_proto,
      from_proto_exn: ListContractorsResponse.from_proto_exn,
      to_proto: ListContractorsResponse.to_proto,
      to_proto$p: ListContractorsResponse.to_proto$p,
      merge: ListContractorsResponse.merge,
      to_json: ListContractorsResponse.to_json,
      from_json_exn: ListContractorsResponse.from_json_exn,
      from_json: ListContractorsResponse.from_json
    }
  },
  listContractors: listContractors,
  CreateContractor: {
    name: "/buhta.document.v1alpha1.ContractorService/CreateContractor",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "CreateContractor",
    $$Request: {
      name: CreateContractorRequest.name,
      make: CreateContractorRequest.make,
      from_proto: CreateContractorRequest.from_proto,
      from_proto_exn: CreateContractorRequest.from_proto_exn,
      to_proto: CreateContractorRequest.to_proto,
      to_proto$p: CreateContractorRequest.to_proto$p,
      merge: CreateContractorRequest.merge,
      to_json: CreateContractorRequest.to_json,
      from_json_exn: CreateContractorRequest.from_json_exn,
      from_json: CreateContractorRequest.from_json
    },
    $$Response: {
      name: CreateContractorResponse.name,
      make: CreateContractorResponse.make,
      from_proto: CreateContractorResponse.from_proto,
      from_proto_exn: CreateContractorResponse.from_proto_exn,
      to_proto: CreateContractorResponse.to_proto,
      to_proto$p: CreateContractorResponse.to_proto$p,
      merge: CreateContractorResponse.merge,
      to_json: CreateContractorResponse.to_json,
      from_json_exn: CreateContractorResponse.from_json_exn,
      from_json: CreateContractorResponse.from_json
    }
  },
  createContractor: createContractor,
  UpdateContractor: {
    name: "/buhta.document.v1alpha1.ContractorService/UpdateContractor",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "UpdateContractor",
    $$Request: {
      name: UpdateContractorRequest.name,
      make: UpdateContractorRequest.make,
      from_proto: UpdateContractorRequest.from_proto,
      from_proto_exn: UpdateContractorRequest.from_proto_exn,
      to_proto: UpdateContractorRequest.to_proto,
      to_proto$p: UpdateContractorRequest.to_proto$p,
      merge: UpdateContractorRequest.merge,
      to_json: UpdateContractorRequest.to_json,
      from_json_exn: UpdateContractorRequest.from_json_exn,
      from_json: UpdateContractorRequest.from_json
    },
    $$Response: {
      name: UpdateContractorResponse.name,
      make: UpdateContractorResponse.make,
      from_proto: UpdateContractorResponse.from_proto,
      from_proto_exn: UpdateContractorResponse.from_proto_exn,
      to_proto: UpdateContractorResponse.to_proto,
      to_proto$p: UpdateContractorResponse.to_proto$p,
      merge: UpdateContractorResponse.merge,
      to_json: UpdateContractorResponse.to_json,
      from_json_exn: UpdateContractorResponse.from_json_exn,
      from_json: UpdateContractorResponse.from_json
    }
  },
  updateContractor: updateContractor,
  DeleteContractor: {
    name: "/buhta.document.v1alpha1.ContractorService/DeleteContractor",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "DeleteContractor",
    $$Request: {
      name: DeleteContractorRequest.name,
      make: DeleteContractorRequest.make,
      from_proto: DeleteContractorRequest.from_proto,
      from_proto_exn: DeleteContractorRequest.from_proto_exn,
      to_proto: DeleteContractorRequest.to_proto,
      to_proto$p: DeleteContractorRequest.to_proto$p,
      merge: DeleteContractorRequest.merge,
      to_json: DeleteContractorRequest.to_json,
      from_json_exn: DeleteContractorRequest.from_json_exn,
      from_json: DeleteContractorRequest.from_json
    },
    $$Response: {
      name: DeleteContractorResponse.name,
      make: DeleteContractorResponse.make,
      from_proto: DeleteContractorResponse.from_proto,
      from_proto_exn: DeleteContractorResponse.from_proto_exn,
      to_proto: DeleteContractorResponse.to_proto,
      to_proto$p: DeleteContractorResponse.to_proto$p,
      merge: DeleteContractorResponse.merge,
      to_json: DeleteContractorResponse.to_json,
      from_json_exn: DeleteContractorResponse.from_json_exn,
      from_json: DeleteContractorResponse.from_json
    }
  },
  deleteContractor: deleteContractor,
  CreateContractorBankAccount: {
    name: "/buhta.document.v1alpha1.ContractorService/CreateContractorBankAccount",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "CreateContractorBankAccount",
    $$Request: {
      name: CreateContractorBankAccountRequest.name,
      make: CreateContractorBankAccountRequest.make,
      from_proto: CreateContractorBankAccountRequest.from_proto,
      from_proto_exn: CreateContractorBankAccountRequest.from_proto_exn,
      to_proto: CreateContractorBankAccountRequest.to_proto,
      to_proto$p: CreateContractorBankAccountRequest.to_proto$p,
      merge: CreateContractorBankAccountRequest.merge,
      to_json: CreateContractorBankAccountRequest.to_json,
      from_json_exn: CreateContractorBankAccountRequest.from_json_exn,
      from_json: CreateContractorBankAccountRequest.from_json
    },
    $$Response: {
      name: CreateContractorBankAccountResponse.name,
      make: CreateContractorBankAccountResponse.make,
      from_proto: CreateContractorBankAccountResponse.from_proto,
      from_proto_exn: CreateContractorBankAccountResponse.from_proto_exn,
      to_proto: CreateContractorBankAccountResponse.to_proto,
      to_proto$p: CreateContractorBankAccountResponse.to_proto$p,
      merge: CreateContractorBankAccountResponse.merge,
      to_json: CreateContractorBankAccountResponse.to_json,
      from_json_exn: CreateContractorBankAccountResponse.from_json_exn,
      from_json: CreateContractorBankAccountResponse.from_json
    }
  },
  createContractorBankAccount: createContractorBankAccount,
  UpdateContractorBankAccount: {
    name: "/buhta.document.v1alpha1.ContractorService/UpdateContractorBankAccount",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "UpdateContractorBankAccount",
    $$Request: {
      name: UpdateContractorBankAccountRequest.name,
      make: UpdateContractorBankAccountRequest.make,
      from_proto: UpdateContractorBankAccountRequest.from_proto,
      from_proto_exn: UpdateContractorBankAccountRequest.from_proto_exn,
      to_proto: UpdateContractorBankAccountRequest.to_proto,
      to_proto$p: UpdateContractorBankAccountRequest.to_proto$p,
      merge: UpdateContractorBankAccountRequest.merge,
      to_json: UpdateContractorBankAccountRequest.to_json,
      from_json_exn: UpdateContractorBankAccountRequest.from_json_exn,
      from_json: UpdateContractorBankAccountRequest.from_json
    },
    $$Response: {
      name: UpdateContractorBankAccountResponse.name,
      make: UpdateContractorBankAccountResponse.make,
      from_proto: UpdateContractorBankAccountResponse.from_proto,
      from_proto_exn: UpdateContractorBankAccountResponse.from_proto_exn,
      to_proto: UpdateContractorBankAccountResponse.to_proto,
      to_proto$p: UpdateContractorBankAccountResponse.to_proto$p,
      merge: UpdateContractorBankAccountResponse.merge,
      to_json: UpdateContractorBankAccountResponse.to_json,
      from_json_exn: UpdateContractorBankAccountResponse.from_json_exn,
      from_json: UpdateContractorBankAccountResponse.from_json
    }
  },
  updateContractorBankAccount: updateContractorBankAccount,
  DeleteContractorBankAccount: {
    name: "/buhta.document.v1alpha1.ContractorService/DeleteContractorBankAccount",
    package_name: "buhta.document.v1alpha1",
    service_name: "ContractorService",
    method_name: "DeleteContractorBankAccount",
    $$Request: {
      name: DeleteContractorBankAccountRequest.name,
      make: DeleteContractorBankAccountRequest.make,
      from_proto: DeleteContractorBankAccountRequest.from_proto,
      from_proto_exn: DeleteContractorBankAccountRequest.from_proto_exn,
      to_proto: DeleteContractorBankAccountRequest.to_proto,
      to_proto$p: DeleteContractorBankAccountRequest.to_proto$p,
      merge: DeleteContractorBankAccountRequest.merge,
      to_json: DeleteContractorBankAccountRequest.to_json,
      from_json_exn: DeleteContractorBankAccountRequest.from_json_exn,
      from_json: DeleteContractorBankAccountRequest.from_json
    },
    $$Response: {
      name: DeleteContractorBankAccountResponse.name,
      make: DeleteContractorBankAccountResponse.make,
      from_proto: DeleteContractorBankAccountResponse.from_proto,
      from_proto_exn: DeleteContractorBankAccountResponse.from_proto_exn,
      to_proto: DeleteContractorBankAccountResponse.to_proto,
      to_proto$p: DeleteContractorBankAccountResponse.to_proto$p,
      merge: DeleteContractorBankAccountResponse.merge,
      to_json: DeleteContractorBankAccountResponse.to_json,
      from_json_exn: DeleteContractorBankAccountResponse.from_json_exn,
      from_json: DeleteContractorBankAccountResponse.from_json
    }
  },
  deleteContractorBankAccount: deleteContractorBankAccount
};

const V1alpha1 = {
  GetContractorRequest: GetContractorRequest,
  GetContractorResponse: GetContractorResponse,
  ListContractorsRequest: ListContractorsRequest,
  ListContractorsResponse: ListContractorsResponse,
  CreateContractorRequest: CreateContractorRequest,
  CreateContractorResponse: CreateContractorResponse,
  UpdateContractorRequest: UpdateContractorRequest,
  UpdateContractorResponse: UpdateContractorResponse,
  DeleteContractorRequest: DeleteContractorRequest,
  DeleteContractorResponse: DeleteContractorResponse,
  CreateContractorBankAccountRequest: CreateContractorBankAccountRequest,
  CreateContractorBankAccountResponse: CreateContractorBankAccountResponse,
  UpdateContractorBankAccountRequest: UpdateContractorBankAccountRequest,
  UpdateContractorBankAccountResponse: UpdateContractorBankAccountResponse,
  DeleteContractorBankAccountRequest: DeleteContractorBankAccountRequest,
  DeleteContractorBankAccountResponse: DeleteContractorBankAccountResponse,
  ContractorBankAccountData: ContractorBankAccountData,
  ContractorService: V1alpha1_ContractorService
};

const $$Document = {
  V1alpha1: V1alpha1
};

const Buhta = {
  $$Document: $$Document
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetContractorRequest Not a pure module */
